





















































import {
  computed,
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import { MODAL_NAMES } from '~/components/common/SimpleModal';
import Tooltip from '~/components/common/Tooltip.vue';
import SvgImage from '~/components/General/SvgImage.vue';
import { ProductPackPropsInterface } from '~/components/Product/types';
import {useTax, useUiState} from '~/composables';
import isServer from '~/helpers/isServer';
import { isMaintenance } from '~/helpers/productHelpers';
import { ProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'PrintHoverText',
  components: {
    Tooltip,
    SvgImage,
  },
  props: {
    product: {
      type: Object as PropType<ProductInterface>,
      required: true,
    },
  },
  setup(props) {
    const { toggleModal } = useUiState();

    const capacity = computed(() => {
      let result = [];

      if (props.product?.capacity?.length) {
        result = props.product.capacity.split(', ');
      }

      return result;
    });
    const { rawPriceCalculationReverse } = useTax();
    const yields = computed(() => props.product.yields);
    const perPagePrice = computed(() => rawPriceCalculationReverse(parseFloat(props.product?.per_page_price), 1) + 'p');
    const isProductMaintenance = computed<boolean>(() => isMaintenance(props.product.group));
    const productPackModalProps = computed<ProductPackPropsInterface>(() => ({
      yields: yields.value,
      capacity: capacity.value,
      isMaintenance: isProductMaintenance.value,
    }));

    const openPackModal = () => {
      if (!yields.value) {
        return;
      }

      toggleModal({
        identifier: MODAL_NAMES.productPack,
        props: {
          productPack: productPackModalProps.value,
        },
      });
    };
    return {
      clientSide: computed(() => !isServer),
      openPackModal,
      isProductMaintenance,
      perPagePrice,
    };
  },
});
